import { useStaticQuery, graphql } from "gatsby";

export const useLatestCategoryArticles = ({ category, filterId }) => {
  const { allMarkdownRemark } = useStaticQuery(
    graphql`
      query LatestCategoryArticles {
        allMarkdownRemark {
          group(field: { frontmatter: { category: SELECT } }, limit: 10) {
            field
            fieldValue
            nodes {
              ...TextArticle
            }
          }
        }
      }
    `
  );
  return allMarkdownRemark.group
    .filter(({ fieldValue }) => fieldValue === category)[0]
    .nodes.filter(({ id }) => id !== filterId);
};
